module.exports = __webpack_public_path__ + "themes/non-default/brandLogo.1919713da0f97cdf9938647bfc8e34e6.svg";